import { styled } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { grey } from "@mui/material/colors";

export const CustomDataGrid = styled(DataGrid)(({ theme }) => [
  {
    backgroundColor: "transparent",
    borderColor: grey[300],
    "& .MuiDataGrid-cell": {
      padding: "6px 8px"
    },
  },
  theme.applyStyles("dark", {
    borderColor: grey[800],
  })
]);